import { H4 } from "../../../AbstractElements";

const TableHeadings = () => {
  const Headings: string[] = ["Item Description", "Hours", "Rate", "Sub-total"];
  return (
    <tr>
      {Headings.map((item, index) => (
        <td className="item" key={index}>
          <H4 className="p-2 mb-0">{item}</H4>
        </td>
      ))}
    </tr>
  );
};

export default TableHeadings;
